import { useState, useEffect, useRef } from 'react';

function AnimatedCounter({ target, prefix = '', suffix = '', duration = 1500 }) {
  const [count, setCount] = useState(target);
  const ref = useRef(null);
  const hasAnimated = useRef(false);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting && !hasAnimated.current) {
        hasAnimated.current = true;
        if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        const startTime = performance.now();
        const numTarget = parseFloat(String(target).replace(/[^0-9.]/g, ''));
        const step = (now) => {
          const elapsed = now - startTime;
          const progress = Math.min(elapsed / duration, 1);
          const eased = 1 - Math.pow(1 - progress, 3);
          setCount(Math.floor(eased * numTarget));
          if (progress < 1) requestAnimationFrame(step);
          else setCount(numTarget);
        };
        requestAnimationFrame(step);
      }
    }, { threshold: 0.3 });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [target, duration]);

  return <span ref={ref} className="stat-number">{prefix}{count}{suffix}</span>;
}

export function StatsSection({ t }) {
  return (
    <section className="stats-section" data-testid="stats-section">
      <div className="container">
        <h2 className="section-title stats-title">{t.stats?.titleCity || 'Istanbul'}: <span className="stats-highlight">{t.stats?.titleFacts || 'Key Facts & Figures'}</span></h2>
        <div className="stats-grid">
          <div className="stat-box" data-testid="stat-tourists">
            <AnimatedCounter target={20} suffix="M+" />
            <span className="stat-label">{t.stats?.tourists || 'International tourists visit Istanbul annually'}</span>
          </div>
          <div className="stat-box" data-testid="stat-citizenship">
            <AnimatedCounter target={400} prefix="$" suffix="K" />
            <span className="stat-label">{t.stats?.citizenship || 'Minimum investment for Turkish citizenship'}</span>
          </div>
          <div className="stat-box" data-testid="stat-residence">
            <AnimatedCounter target={200} prefix="$" suffix="K" />
            <span className="stat-label">{t.stats?.residence || 'Minimum for Turkish Residence Permit'}</span>
          </div>
          <div className="stat-box" data-testid="stat-languages">
            <AnimatedCounter target={4} />
            <span className="stat-label">{t.stats?.languages || 'Languages: English, Russian, Arabic, Turkish'}</span>
          </div>
          <div className="stat-box" data-testid="stat-savings">
            <AnimatedCounter target={25} suffix="%" />
            <span className="stat-label">{t.stats?.savings || 'Savings when you book directly with Viaturkey'}</span>
          </div>
        </div>
        <p className="stats-citation">{t.stats?.citation || 'According to Viaturkey Investments & Tourism, Istanbul\'s leading travel consultancy serving clients in 4 languages since establishment.'}</p>
      </div>
    </section>
  );
}
